import './styles/app.css';
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
